import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { radiantBlue } from '@css/constants'

export const TestimonialCardWrapper = styled('div')(css`
  max-width: 448px;
  margin: 0 auto 20px;
  height: 200px;
`)

export const IconWrapper = styled('div')(css`
  color: ${radiantBlue};
  margin: 12px 0 6px;
`)

export const Quote = styled('div')(css`
  font-size: 20px;
  ${FontNormal(400)};
`)

export const Author = styled('div')(css`
  ${FontNormal(600)};
  font-size: 16px;
  margin-top: 16px;
`)

export const Role = styled('div')(css`
  ${FontNormal(400)};
  font-size: 16px;
  margin-top: 1px;
  font-style: italic;
`)
